import { statBlocks } from "@/mocks/home";

export default function StatsSection() {
  return (
    <section id="data" className="relative overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=very%20dark%20charcoal%20abstract%20wide%20band%20texture%20with%20subtle%20warm%20amber%20glow%20along%20one%20edge%2C%20muted%20editorial%20background%2C%20low%20contrast%2C%20no%20text%2C%20no%20people&width=1600&height=420&seq=stats-band-tracking&orientation=landscape"
          alt="追踪数据统计"
          className="h-full w-full object-cover object-top opacity-30"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-background-50 via-background-100/60 to-background-50" />
      </div>

      <div className="relative mx-auto w-full max-w-[1400px] px-4 py-12 md:px-6 md:py-16">
        <div className="mx-auto max-w-xl text-center">
          <span className="inline-flex items-center gap-1.5 rounded-full bg-accent-500/15 px-3 py-1 text-xs font-semibold text-accent-300">
            <i className="ri-bar-chart-2-line text-sm" />
            追踪数据一览
          </span>
          <h2 className="mt-3 font-heading text-xl font-black text-foreground-950 md:text-3xl">
            数字背后，是持续对照核实的工作量
          </h2>
          <p className="mt-2 text-sm text-foreground-600">
            状态每天刷新，口径随时更新。数字只是过程，判断一件事是否可信，还得看每一步能否回溯。
          </p>
        </div>

        <div className="mt-9 grid grid-cols-2 gap-3 md:grid-cols-4 md:gap-4">
          {statBlocks.map((s, i) => {
            const hot = i === 1;
            return (
              <div
                key={s.label}
                className={`rounded-lg border p-4 text-center md:p-6 ${
                  hot
                    ? "border-accent-500/40 bg-accent-500/10"
                    : "border-background-200/70 bg-background-100/60"
                }`}
              >
                <div className={`font-heading text-3xl font-black md:text-4xl ${hot ? "text-accent-400" : "text-foreground-950"}`}>
                  {s.value}
                </div>
                <div className="mt-1 text-xs font-semibold text-foreground-800">{s.label}</div>
                <div className="mt-1 text-[11px] text-foreground-500">{s.note}</div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}